import React from "react"
import WidgetInputCurrency from "./WidgetInputCurrency"
import SelectWidget from "./SelectWidget"
import MultiSelectWidget from "./MultiSelectWidget"
import BaseTextInput from "./BaseTextInput"
import NumberInput from "./NumberInput"
import PercentWithTwoDecimal from "./PercentWithTwoDecimal"
import DatePicker from "./DatePicker"
import YearPicker from "./YearPicker"
import SwitchWidget from "./SwitchWidget"
import {getAntworttyp} from "../../misc/widget-functions"

export const AntworttypMap = Object.freeze({
    YESNO: SwitchWidget,
    INTEGER: NumberInput,
    FLOAT: NumberInput,
    STRING: BaseTextInput,
    ENUMERATION_SINGLE: SelectWidget,
    ENUMERATION_MULTI: MultiSelectWidget,
    PERCENTAGE: PercentWithTwoDecimal,
    MONETARYAMOUNT: WidgetInputCurrency,
    DATE: DatePicker,
    YEAR: YearPicker,
})

const AttributeInputWidget = (props) => {
    const antworttyp = getAntworttyp(props.widget)
    const Renderer = AntworttypMap[antworttyp]
    if (!Renderer) {
        console.warn(
            "AttributeInputWidget: kein Mapping für antworttyp",
            antworttyp,
            props.widget,
        )
        return null
    }
    return <Renderer {...props} />
}

export default AttributeInputWidget
